import { useEffect } from "react"
import { useMatches } from "react-router-dom"

import { trackNavigated } from "../services/tracking"

export function NavigationTracker() {
  const routeId = useMatches().at(-1)?.id

  useEffect(() => {
    if (!routeId) return

    trackNavigated({
      route: routeId,
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
    })
  }, [routeId])

  return null
}
